import { calculateKvm } from './calculateKvm'

// 3.14, not Math.PI, on purpose. It is the constant the business formulas are
// defined with (SalesCalculations.md) and the value every existing order was
// priced at. Math.PI would silently change invoiced amounts.
const GLASS_PI = 3.14

/**
 * DUMALOQ - a full-circle service billed per metre of cut edge.
 *
 * Circumference is PI * diameter, and `width` holds the diameter, so there is
 * no factor of 2 here. (2 * PI * r is the same length expressed from the
 * radius - multiplying `width` by 2 * PI would double-count the edge.)
 */
const circleServiceQuantity = (width, itemQuantity) =>
	(GLASS_PI * width * itemQuantity) / 1000

/** Circle shape entered as one measured side value (mm -> m). */
const circleShapeQuantity = (value) => (GLASS_PI * value) / 1000

/** SemiCircle shape - half of the entered value (mm -> m). */
const semiCircleShapeQuantity = (value) => (GLASS_PI * (value / 2)) / 1000

/** Free-form shape: sum of the entered sides (mm -> m). */
const shapeSidesQuantity = (values) =>
	values.reduce((acc, val) => acc + parseFloat(val || 0), 0) / 1000

/** KALIT - perimeter: 2 * (width + height), mm -> m, times quantity. */
const perimeterQuantity = (width, height, quantity) =>
	((+width + +height) / 1000) * 2 * quantity

const calculateShtPrices = (selectedServices, priceKey = 'price') => {
	return selectedServices.reduce((acc, service) => {
		if (
			service.ugpName === 'шт' &&
			!service.isKalitParametr &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'Key_Sketches' &&
			service.u_Modal !== 'Rhombic_Sketches' &&
			service.u_Modal !== 'ort'
		) {
			return (
				acc +
				service[priceKey] * service.quantity * service.itemQuantity
			)
		} else if (
			service.ugpName === 'шт' &&
			service.isKalitParametr &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'Key_Sketches' &&
			service.u_Modal !== 'Rhombic_Sketches' &&
			service.u_Modal !== 'ort'
		) {
			return (
				acc +
				service[priceKey] *
					(service.u_ParametrQuantityValues * service.itemQuantity)
			)
		}
		return acc
	}, 0)
}

const calculateMetrPriceServices = (selectedServices, priceKey = 'price') => {
	return (
		selectedServices?.reduce((acc, service) => {
			if (
				service.ugpName === 'м' &&
				service.u_Modal === 'Circle_Services' &&
				service.u_Modal !== 'Templete_Services' &&
				service.u_Modal !== 'ort'
			) {
				return (
					acc +
					service[priceKey] *
						circleServiceQuantity(
							service.width,
							service.itemQuantity,
						)
				)
			} else if (
				service.ugpName === 'м' &&
				!service.isParametr &&
				service.u_Modal !== 'Circle_Services' &&
				service.u_Modal !== 'Templete_Services' &&
				service.u_Modal !== 'ort' &&
				service.u_Modal !== 'Telefon'
			) {
				return (
					acc +
					service[priceKey] *
						((((service.width + service.height) * 2) / 1000) *
							service.quantity)
				)
			} else if (
				service.u_Modal === 'Templete_Services' ||
				service.u_Modal === 'Telefon'
			) {
				return (
					acc +
					service[priceKey] * service.quantity * service.itemQuantity
				)
			}
			return acc
		}, 0) || 0
	)
}

const calculateMetrPriceParametr = (selectedServices, priceKey = 'price') => {
	return selectedServices?.reduce((acc, service) => {
		if (
			service.ugpName === 'м' &&
			service.isParametr &&
			service.u_Modal !== 'Circle_Services' &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'ort'
		) {
			return (
				acc +
				service.itemQuantity *
					(service[priceKey] *
						(service.u_ParametrQuantityValues * service.quantity))
			)
		}
		return acc
	}, 0)
}

const calculateKvmPrices = (selectedServices, priceKey = 'price') => {
	return selectedServices?.reduce((acc, service) => {
		if (
			service.ugpName !== 'шт' &&
			service.ugpName !== 'м' &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'ort'
		) {
			return acc + service[priceKey]
		}
		return acc
	}, 0)
}

const calculateSelectedServicesRowTotal = (row, priceKey = 'price') => {
	return row?.selectedServices?.reduce((acc, service) => {
		if (
			service.ugpName !== 'шт' &&
			service.ugpName !== 'м' &&
			service.u_Modal !== 'Templete_Services' &&
			service.u_Modal !== 'ort'
		) {
			return (
				acc +
				service[priceKey] *
					(calculateKvm(row?.width, row?.height) * row?.quantity)
			)
		}
		return acc
	}, 0)
}

export {
	GLASS_PI,
	circleServiceQuantity,
	circleShapeQuantity,
	semiCircleShapeQuantity,
	shapeSidesQuantity,
	perimeterQuantity,
	calculateShtPrices,
	calculateMetrPriceServices,
	calculateMetrPriceParametr,
	calculateKvmPrices,
	calculateSelectedServicesRowTotal,
}
